import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { CurrentUserService } from 'projects/services/src/app/current-user.service';
import { Location } from '@angular/common';
import { TrainingCentersService } from 'projects/services/src/app/API/training-centers.service';

@Component({
  selector: 'app-msg-centre-tp',
  templateUrl: './msg-centre-tp.component.html',
  styleUrls: ['./msg-centre-tp.component.css']
})
export class MsgCentreTpComponent implements OnInit {

  emailMessages: any = [];
	actorName: any;
	appstageArray: any = [];
	actorType: any;
	@Input() trainingCentreId: any;
	stages: any = [];
	tpId: any;
	constructor(
		private router: Router,
		private trainingCentreService: TrainingCentersService,
		private currentUserService: CurrentUserService,
		private location: Location
	) { }

	ngOnInit() {
		this.currentUserService.getAdditionalInfomartion().subscribe(user => {
			this.tpId = user.userName;
			this.actorType = user.role;
		 	this.getAllStages();
			// this.getMessages();

		})
	}
	goBack() {
		// this.router.navigate(['/trainingcentre/training-of-trainers/tc-edit-caaf']);
		this.location.back();
	}

	getAllStages() {
		console.log('method')
		const emailmsg = []
		// const tcId = this.trainingCentreId ? this.trainingCentreId : this.actorName;
			this.trainingCentreService.getApplicationStageListTP(this.tpId).subscribe(res => {
				if (res) {
					this.stages = res.stages;
					res.messages.forEach(function (obj, index) {
						if (obj.msg === '') {
							res.messages.splice(index, 1)
						} else {
							emailmsg.push(obj)
						}
					});

					this.emailMessages = emailmsg;

				}
			})
	}

}
